import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { State } from '../../../../reducers'
import { AlertsStore } from '../../../../typings/stores/AlertsStore'

import AlertsTable from '../../../../pages/Alerts/AlertsTable'

import styles from './styles.module.css'

const Alerts: FunctionComponent<{
  alerts: AlertsStore
  className?: string
}> = ({ alerts, className }) => {
  const alertsLoading = useSelector<State, boolean>(
    state => state.alerts.status === 'fetching'
  )

  return (
    <div className={classnames(styles.container, className)}>
      <h2 className={styles.title}>Latest Alerts</h2>
      <AlertsTable
        loading={alertsLoading}
        alerts={alerts}
        paginate={false}
        sortable={false}
      />
    </div>
  )
}

export default Alerts
